const defaultState = {
  locations: [],
  departments: [],
  positions: [],
  isFetching: false,
}

// actions
const LOAD = 'st-career/openings/LOAD'
const FETCH = 'st-career/openings/FETCH'

// reducer
export default function (state = defaultState, action) {
  switch (action.type) {
    case LOAD: {
      const data = action.data
      return {
        locations: data.locations,
        departments: data.departments,
        positions: data.positions,
        isFetching: false,
      }
    }

    case FETCH: {
      return {
        ...state,
        isFetching: action.data,
      }
    }

    default: {
      return state
    }
  }
}

// Action Creators
export function loadOpenings (data) {
  return { type: LOAD, data }
}

export function setIsFetching (data) {
  return { type: FETCH, data }
}
